import { render } from "./Content.vue?vue&type=template&id=f3284352"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import exportComponent from "/home/abushotal/Documents/VUE PROJECTS/LOTUS PORTALS/Comedy-lotus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__